import React, {useContext, useState} from 'react';
import {SystemManager_API} from "../../SystemManager.API";
import {useHttp} from "../../../../hooks/http.hook";
import {AuthContext} from "../../../../context/AuthContext";
import OrgPage from "../../../../components/OrgPage";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {useParams} from "react-router-dom";
import IconCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";


function Doctors() {
    const {
        getDoctors
    } = SystemManager_API.doctors

    const {token} = useContext(AuthContext)
    const [refresh, setRefresh] = useState(false)
    const {verCenterId,verCenterName} = useParams()


    const linkCellToPrices = props => {
        return <IconCell iconName={'pencil'} to={process.env.REACT_APP_URL_PREFIX + 
					`/counterAgents/verificationCenters/${verCenterId}/${verCenterName}/doctorprices/${props.idArr[0]}/${props.cellContent}/prices`}/>
    }


    return (
        <OrgPage
            url={`${process.env.REACT_APP_BASE_URL}` + getDoctors(token.userId).api + "verification_center_id="+verCenterId+"&"}
            refresh={refresh}
            exportTemplateButtons={{export: false, registry: false}}
            filterBarButtons={{downloadTemplate: {show: false,}}}
            filterFieldsConf={{
                fio: true,
                verCenter: false,
                city: true,
                specialization: true,
                doctorStatus: true
            }}
            breadCrumbsItems={[
				{title: 'Контрагенты'},
				{title: 'Удостоверяющие центры',  link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters`},
				{title: verCenterName},
				{title: 'Доктора', actual: true},
            ]}

            firstRow={[
                {title: 'ФИО', id: 'fio'},
                {title: 'Город'},
                {title: 'Специализация'},
                {title: 'Рейтинг', id: 'rating'},
                {title: 'Статус'},
                {title: 'Цены'},
            ]}

            haveToShow={[
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.fio}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.city}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.specialization ? props.all.specialization.join(', '): ""}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.rating}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={props.all.status}/>}},
				{id: 'fio', type: 'wrapperCell', idArr: ['id'], typeData: {cell: linkCellToPrices}},
            ]}
        />

    );
}

export default Doctors;